import React, { useCallback, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

import { IconCircleBell } from 'src/components/Icons/CircleBell';
import { IconCross } from 'src/components/Icons/Cross';
import { UiButton } from 'src/components/UI/Button';
import { DOM_ELEMENT_FOR_PORTALS } from 'src/config';
import { useTHelper } from 'src/utils/i18n';
import { PubNub } from 'src/utils/PubNub';

export const LivestreamStartedBanner: React.FC = () => {
  const [show, setShow] = useState(false);

  const tHelper = useTHelper('livestreamStartedBanner');

  const onClose = useCallback(() => {
    setShow(false);
  }, []);

  /** subscribe to an event */
  useEffect(() => {
    if (window.liveStreamCampaignInfo?.pubnubChannel) {
      PubNub.joinChannel(window.liveStreamCampaignInfo.pubnubChannel, () => {
        setShow(true);
      });
    }
  }, []);

  return show
    ? createPortal(
        <div className="livestream-has-started-banner SecondaryPageBackgroundColor">
          <div className="livestream-has-started-banner-header">
            <div role="presentation" className="livestream-has-started-banner-close" onClick={onClose}>
              <IconCross />
            </div>
          </div>
          <div className="livestream-has-started-banner-body">
            <div className="livestream-has-started-banner-title-container">
              <IconCircleBell />

              <div className="livestream-has-started-banner-title SecondaryPageBackgroundTextColor">
                {tHelper('title')}
              </div>
            </div>
            <div className="livestream-has-started-banner-description SecondaryPageBackgroundTextColor">
              {tHelper('info')}
            </div>
          </div>
          <div className="livestream-has-started-banner-button-container">
            <UiButton tag="a" className="LinkTextColor" onClick={onClose}>
              {tHelper('closeBtnText')}
            </UiButton>
            <UiButton
              className="btn-primary"
              onClick={() => {
                window.location.reload();
              }}
            >
              {tHelper('viewBtnText')}
            </UiButton>
          </div>
        </div>,
        DOM_ELEMENT_FOR_PORTALS
      )
    : null;
};
